import { PaperMergeChild } from "./qpaper-merge-child.model";

export class QPaperMergeCreateReqModel {
    id: number;
    classId: number;
    noOfParts: number;
    paperName: string;
    paperMergeChild: PaperMergeChild[]

    constructor(id: number,classId: number, noOfParts: number, paperName: string, paperMergeChild: PaperMergeChild[]) {
        this.id = id;
        this.classId = classId;
        this.noOfParts = noOfParts;
        this.paperName = paperName;
        this.paperMergeChild = paperMergeChild;
    }
}